import useGetMyPermissions from '~/features/user/hooks/useGetMyPermissions'

/**
 * Subscribes to the shared my-permissions query without fetching.
 * A single active fetch must run elsewhere (see RootConfigLayout); otherwise
 * every mount with `enabled: true` would refetch and race (e.g. on error + retryOnMount).
 */
const useGetMyPermissionsFromCache = () =>
  useGetMyPermissions({ options: { enabled: false } })

export default useGetMyPermissionsFromCache
